import { api } from './AxiosBaseService'
import type { ListParams, PaginatedResponse, SingleResponse } from '@/types/api'

/**
 * Builder de service CRUD genérico. Cada módulo exporta um service tipado:
 *
 *   export const PlansService = createCrudService<Plan>('/commercial/plans')
 *
 * O search field por default é `name[like]`; pode ser sobrescrito.
 */
export function createCrudService<TItem, TPayload = Partial<TItem>>(
  basePath: string,
  options?: { searchField?: string },
) {
  const searchField = options?.searchField ?? 'name'

  return {
    async list(params: ListParams = {}): Promise<PaginatedResponse<TItem>> {
      const { search, ...rest } = params
      const query: Record<string, unknown> = { ...rest }
      if (search) {
        query[`${searchField}[like]`] = search
      }
      const res = await api.get<PaginatedResponse<TItem>>(basePath, { params: query })
      return res.data
    },

    async show(id: string): Promise<TItem> {
      const res = await api.get<SingleResponse<TItem>>(`${basePath}/${id}`)
      return res.data.data
    },

    async create(payload: TPayload): Promise<TItem> {
      const res = await api.post<SingleResponse<TItem>>(basePath, payload)
      return res.data.data
    },

    async update(id: string, payload: TPayload): Promise<TItem> {
      const res = await api.put<SingleResponse<TItem>>(`${basePath}/${id}`, payload)
      return res.data.data
    },

    async destroy(id: string): Promise<void> {
      await api.delete(`${basePath}/${id}`)
    },

    async setStatus(id: string, status: 'ATIVO' | 'INATIVO'): Promise<TItem> {
      const res = await api.put<SingleResponse<TItem>>(`${basePath}/${id}/status`, { status })
      return res.data.data
    },
  }
}
